class ProductModalSwipe extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('modal-dialog');
    this.mediaGallery = document.querySelector('.product__media-list');
    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    
    this.init();
  }

  init() {
    if (!this.modal) return;
    
    // Add touch event listeners for swipe
    this.modal.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.modal.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });
    this.modal.addEventListener('touchend', this.handleTouchEnd.bind(this));
    
    // Add wheel event for desktop scroll
    this.modal.addEventListener('wheel', this.handleWheel.bind(this), { passive: false });
  }

  handleTouchStart(e) {
    this.touchStartX = e.changedTouches[0].screenX;
  }

  handleTouchMove(e) {
    this.touchEndX = e.changedTouches[0].screenX;
  }

  handleTouchEnd() {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swiped left - next image
        this.navigateImage('next');
      } else {
        // Swiped right - previous image
        this.navigateImage('prev');
      }
    }
  }

  handleWheel(e) {
    if (window.innerWidth >= 750) return; // Only on mobile
    
    e.preventDefault();
    
    if (e.deltaY > 0) {
      this.navigateImage('next');
    } else if (e.deltaY < 0) {
      this.navigateImage('prev');
    }
  }

  navigateImage(direction) {
    if (!this.mediaGallery) return;
    
    const mediaItems = this.mediaGallery.querySelectorAll('.product__media-item');
    if (mediaItems.length <= 1) return;
    
    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % mediaItems.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + mediaItems.length) % mediaItems.length;
    }
    
    const targetMedia = mediaItems[this.currentIndex];
    const button = targetMedia.querySelector('button[data-media-id]');
    
    if (button) {
      button.click();
    }
  }
}

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModalSwipe);
}
